import { withFormik } from 'formik'
/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')

import { TwoFactForm } from '../../../components/pages/LoginForm/TwoFactForm'
import { Props } from '../../../components/pages/Login/TwoFact'

export type Values = {
  two_fact_key: string;
}

const withFormikComp = withFormik<Props, Values, Values>({
  displayName: 'TwoFactForm',

  mapPropsToValues: (props) => {
    return {
      two_fact_key: '',
    }
  },

  validationSchema: Yup.object().shape({
    two_fact_key: Yup.string().required('Two factor auth key is required'),
  }),

  validateOnChange: true,

  handleSubmit: (values, { props: { login, history } }) => {
    login(values, history)
  },
})

export default withFormikComp(TwoFactForm)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/LoginForm/TwoFactForm.tsx